export type VehicleStatus = "used" | "new" | "all";
export function VehicleStatusFromString(rawVehicleStatus: string): VehicleStatus
{
    var validStatuses:VehicleStatus[] = ["used", "new", "all"];
  
    return validStatuses.find(v => v == rawVehicleStatus) ?? "used";    
}
